export default "__VITE_ASSET__BWmV7GNo__"